<script setup lang="ts">
import { computed } from 'vue'
import type { UserCourseStatusChipKollegeUserFragment } from './UserCourseStatusChip.generated'

const props = defineProps<{
  user: UserCourseStatusChipKollegeUserFragment
}>()

type Chip = {
  text: string
  color: 'red' | 'green' | 'blue' | 'gray'
}

const userCourseStatusChip = computed((): Chip => {
  if (
    props.user.standardCourse == null ||
    props.user.standardCourse.status === 'NOT_APPLIED'
  ) {
    return { text: '未申込', color: 'red' }
  }

  if (props.user.standardCourse.status === 'APPLIED') {
    return { text: '講師登録待ち', color: 'red' }
  }

  if (props.user.standardCourse.status === 'IN_PROGRESS') {
    return { text: '受講中', color: 'green' }
  }

  if (props.user.standardCourse.status === 'COMPLETED') {
    return { text: '受講終了', color: 'blue' }
  }

  if (props.user.standardCourse.status === 'CANCELLED') {
    return { text: '解約', color: 'gray' }
  }

  return { text: '不明なステータス', color: 'gray' }
})
</script>

<template>
  <span
    v-if="user.standardCourse"
    :class="[$style.chip, $style[`chip--${userCourseStatusChip.color}`]]"
  >
    {{ userCourseStatusChip.text }}
  </span>
</template>

<style lang="scss" module>
.chip {
  border-radius: 100vmax;
  padding: 6px 12px 8px;
  line-height: 1;
  color: $color-text-and-object-high-emphasis-inverse;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;

  &--red {
    background-color: $color-label-red;
  }

  &--green {
    background-color: $color-label-green;
  }

  &--blue {
    background-color: $color-label-blue;
  }

  &--gray {
    background-color: $color-label-gray;
  }
}
</style>
